import { render, staticRenderFns } from "./JobStatusBadge.vue?vue&type=template&id=7ca8258b&scoped=true"
import script from "./JobStatusBadge.vue?vue&type=script&lang=js"
export * from "./JobStatusBadge.vue?vue&type=script&lang=js"
import style0 from "./JobStatusBadge.vue?vue&type=style&index=0&id=7ca8258b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ca8258b",
  null
  
)

export default component.exports